import { MetricPanel } from "./AnalyticsVisuals";
import { ShoppingCartOutlined } from "@mui/icons-material";

import { PurchaseAnalytics as PurchaseAnalyticsType } from "../types";

interface PurchaseAnalyticsProps {
  data?: PurchaseAnalyticsType | null;
}

const PurchaseAnalytics = ({ data }: PurchaseAnalyticsProps) => {
  const rows = [
    ["Bills", data?.totalBills ?? 0],
    ["Pending", data?.pendingBills ?? 0],
    ["Completed", data?.completedBills ?? 0],
    ["Cancelled", data?.cancelledBills ?? 0],
    ["Purchase Cost", `Rs ${data?.totalPurchaseAmount?.toLocaleString() ?? 0}`],
  ];

  return <MetricPanel title="Procurement Analytics" rows={rows} icon={<ShoppingCartOutlined />} />;
};

export default PurchaseAnalytics;
